"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uris_1 = require("../../globals/uris");
const autocontrol_1 = require("../autocontrol");
/**
 * Ramp controls that gradually interpolate between given values.
 */
class RampControl extends autocontrol_1.AutoControl {
    constructor(uri, duration, store, initialValue) {
        super(uri, uris_1.RAMP, store);
        this.duration = duration ? duration : 10000;
        this.currentValue = initialValue ? initialValue : 0;
        this.isIncreasing = this.currentValue != 1;
        this.updateValue(this.currentValue);
    }
    update() {
        //TODO IMPROVE, ONLY CALCULATE WHEN FREQUENCY CHANGES!!!
        var delta = 1 / this.duration * this.frequency;
        if (!this.isIncreasing) {
            delta *= -1;
        }
        this.currentValue += delta;
        if (0 < this.currentValue && this.currentValue < 1) {
            this.updateValue(this.currentValue);
        }
        else if (this.currentValue >= 1) {
            this.updateValue(1);
            this.reset();
        }
        else if (this.currentValue <= 0) {
            this.updateValue(0);
            this.reset();
        }
    }
    reset() {
        super.reset();
        this.isIncreasing = !this.isIncreasing;
    }
}
exports.RampControl = RampControl;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/controls/auto/rampcontrol.js
// module id = 1292
// module chunks = 3